import React from 'react';

const DocumentToolbar = ({ onPrint, onClear }) => {
  const handlePrint = () => {
    window.print();
    if (onPrint) onPrint();
  };

  const handleExportPDF = () => {
    window.print();
  };

  return (
    <div style={styles.toolbar} className="no-print">
      <div style={styles.leftSection}>
        <div style={styles.titleIcon}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
          </svg>
        </div>
        <span style={styles.title}>Lesson Plan Document</span>
      </div>
      <div style={styles.rightSection}>
        <button
          style={styles.button}
          onClick={onClear}
          title="Clear document"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="3 6 5 6 21 6" />
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          </svg>
          Clear
        </button>
        <button
          style={styles.button}
          onClick={handleExportPDF}
          title="Export as PDF (uses browser print dialog)"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
            <polyline points="14 2 14 8 20 8" />
            <line x1="12" y1="18" x2="12" y2="12" />
            <line x1="9" y1="15" x2="15" y2="15" />
          </svg>
          Export PDF
        </button>
        <button
          style={{ ...styles.button, ...styles.primaryButton }}
          onClick={handlePrint}
          title="Print document"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6 9 6 2 18 2 18 9" />
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
            <rect x="6" y="14" width="12" height="8" />
          </svg>
          Print
        </button>
      </div>
    </div>
  );
};

const styles = {
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '14px 20px',
    backgroundColor: 'white',
    borderBottom: '1px solid var(--gray-200)',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  titleIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    borderRadius: 'var(--radius-md)',
    backgroundColor: 'var(--primary-50)',
    color: 'var(--primary-600)',
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  title: {
    fontSize: '15px',
    fontWeight: '600',
    color: 'var(--gray-900)',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '8px 14px',
    fontSize: '13px',
    fontWeight: '500',
    color: 'var(--gray-700)',
    backgroundColor: 'white',
    border: '1px solid var(--gray-300)',
    borderRadius: 'var(--radius-md)',
    cursor: 'pointer',
    transition: 'all var(--transition-fast)',
  },
  primaryButton: {
    background: 'linear-gradient(135deg, var(--primary-500) 0%, var(--primary-600) 100%)',
    color: 'white',
    border: '1px solid var(--primary-500)',
    boxShadow: '0 2px 4px rgba(37, 99, 235, 0.15)',
  },
};

export default DocumentToolbar;
